export interface ProgramHost {
  id: number;
  name: string;
  photoUrl: string;
  role: string;
}

export interface ProgramCommunity {
  followers: number;
  comments: number;
  shares: number;
  notificationEnabled: boolean;
}

export interface Program {
  id: number;
  name: string;
  slug: string;
  coverUrl: string;
  description: string;
  schedule: string;
  timezone: string;
  hosts: ProgramHost[];
  followers: number;
  category: string;
  radioName: string;
  radioFrequency: string;
  radioId: number;
  community: ProgramCommunity;
  isActive: boolean;
  createdAt: string;
  tags: string[];
}

export type ProgramCategory = 'Música' | 'Deportes' | 'Noticias' | 'Entretenimiento' | 'Cultura' | 'Educación' | 'Salud' | 'Tecnología' | 'Finanzas' | 'Comedia';

export const programsCategories: ProgramCategory[] = [
  'Música', 'Deportes', 'Noticias', 'Entretenimiento', 'Cultura', 'Educación', 'Salud', 'Tecnología', 'Finanzas', 'Comedia',
];

export const programs: Program[] = [
  {
    id: 1,
    name: 'Mañanas Argentinas',
    slug: 'mananas-argentinas',
    coverUrl: 'https://readdy.ai/api/search-image?query=Professional%20radio%20morning%20show%20studio%20scene%20with%20warm%20sunrise%20lighting%20through%20large%20windows%2C%20multiple%20microphones%20on%20a%20wooden%20desk%2C%20coffee%20cups%2C%20newspapers%20scattered%2C%20energetic%20and%20inviting%20atmosphere%2C%20editorial%20broadcast%20photography%20with%20soft%20golden%20hour%20tones%20and%20clean%20modern%20studio%20aesthetic&width=800&height=450&seq=program-cover-mananas-argentinas&orientation=landscape',
    description: 'El despertar de Argentina comienza aquí. Noticias, entrevistas a fondo, debates con los protagonistas de la actualidad y la mejor música para arrancar el día. Más de 15 años siendo el programa matutino de referencia con cobertura en vivo de los acontecimientos más importantes del país. Martín Castellanos lidera un equipo de 8 periodistas que traen la información con profundidad, contexto y cercanía.',
    schedule: 'Lun-Vie 06:00-10:00',
    timezone: 'ART (UTC-3)',
    hosts: [
      { id: 1, name: 'Martín Castellanos', photoUrl: 'https://readdy.ai/api/search-image?query=Professional%20male%20radio%20host%20in%20his%20thirties%2C%20warm%20confident%20expression%2C%20studio%20microphone%20in%20background%20softly%20blurred%2C%20casual%20elegant%20dark%20shirt%2C%20warm%20studio%20lighting%2C%20editorial%20portrait%20photography&width=200&height=200&seq=host-martin-c-thumb&orientation=squarish', role: 'Conductor Principal' },
    ],
    followers: 284000,
    category: 'Noticias',
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.5 FM',
    radioId: 1,
    community: { followers: 284000, comments: 45200, shares: 12800, notificationEnabled: true },
    isActive: true,
    createdAt: '2024-03-10',
    tags: ['noticias', 'actualidad', 'entrevistas', 'matutino', 'política'],
  },
  {
    id: 2,
    name: 'Tardes con Vale',
    slug: 'tardes-con-vale',
    coverUrl: 'https://readdy.ai/api/search-image?query=Energetic%20afternoon%20radio%20show%20studio%2C%20colorful%20neon%20signs%20on%20walls%2C%20modern%20pop%20culture%20aesthetic%2C%20pink%20and%20warm%20orange%20ambient%20lighting%2C%20DJ%20mixer%20visible%2C%20vibrant%20youthful%20broadcast%20atmosphere%2C%20editorial%20photography%20with%20clean%20modern%20composition&width=800&height=450&seq=program-cover-tardes-con-vale&orientation=landscape',
    description: 'El punto de encuentro de la generación conectada. Música, cultura pop, virales, entrevistas a influencers y artistas del momento. Valentina Ríos revolucionó la radio juvenil con un formato ágil que combina streaming, redes sociales y radio tradicional. El chat en vivo del programa es una comunidad vibrante donde los oyentes deciden qué suena y qué se discute.',
    schedule: 'Lun-Vie 16:00-19:00',
    timezone: 'CST (UTC-6)',
    hosts: [
      { id: 2, name: 'Valentina Ríos', photoUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20in%20her%20late%20twenties%2C%20friendly%20smile%2C%20modern%20broadcast%20studio%20with%20warm%20lighting%2C%20stylish%20cream%20blazer%2C%20headphones%20around%20neck%2C%20editorial%20portrait%20photography&width=200&height=200&seq=host-valentina-r-thumb&orientation=squarish', role: 'Conductora' },
    ],
    followers: 512000,
    category: 'Entretenimiento',
    radioName: 'Estéreo Capital',
    radioFrequency: '102.1 FM',
    radioId: 2,
    community: { followers: 512000, comments: 98500, shares: 34200, notificationEnabled: true },
    isActive: true,
    createdAt: '2024-06-22',
    tags: ['juvenil', 'cultura-pop', 'música', 'influencers', 'tendencias'],
  },
  {
    id: 3,
    name: 'Deporte Total',
    slug: 'deporte-total',
    coverUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20radio%20studio%20with%20multiple%20large%20screens%20showing%20live%20match%20highlights%2C%20sports%20memorabilia%20on%20shelves%2C%20professional%20broadcast%20desk%20with%20sports%20team%20branding%2C%20dramatic%20stadium-like%20lighting%20with%20green%20field%20tones%2C%20editorial%20sports%20photography%20style&width=800&height=450&seq=program-cover-deporte-total&orientation=landscape',
    description: 'La cita obligada del deporte latinoamericano. Tres horas de análisis táctico profundo, cobertura en directo de las principales ligas y competiciones, y la opinión más respetada del periodismo deportivo. Beto Fuentes y su equipo de 5 especialistas desmenuzan cada jugada con pasión y rigor. El programa con más interacciones en vivo de toda la plataforma.',
    schedule: 'Lun-Vie 18:00-21:00',
    timezone: 'CST (UTC-6)',
    hosts: [
      { id: 3, name: 'Roberto "Beto" Fuentes', photoUrl: 'https://readdy.ai/api/search-image?query=Male%20radio%20sports%20commentator%20in%20his%20forties%2C%20energetic%20expression%2C%20polo%20shirt%2C%20sports%20broadcast%20studio%20with%20screens%2C%20dynamic%20energy%2C%20editorial%20portrait&width=200&height=200&seq=host-beto-f-thumb&orientation=squarish', role: 'Conductor Principal' },
    ],
    followers: 385000,
    category: 'Deportes',
    radioName: 'Radio Deportiva Total',
    radioFrequency: '95.7 FM',
    radioId: 3,
    community: { followers: 385000, comments: 142000, shares: 28500, notificationEnabled: true },
    isActive: true,
    createdAt: '2024-01-15',
    tags: ['fútbol', 'deportes', 'análisis', 'cobertura-en-vivo', 'ligas'],
  },
  {
    id: 4,
    name: 'Conversaciones Reales',
    slug: 'conversaciones-reales',
    coverUrl: 'https://readdy.ai/api/search-image?query=Intimate%20warm%20radio%20studio%20atmosphere%20with%20soft%20amber%20lighting%2C%20comfortable%20armchairs%20facing%20each%20other%2C%20acoustic%20panels%20on%20walls%2C%20plants%20for%20a%20calming%20environment%2C%20gentle%20candle-like%20warm%20glow%2C%20editorial%20photography%20with%20emotional%20depth%20and%20safe%20space%20aesthetic&width=800&height=450&seq=program-cover-conversaciones-reales&orientation=landscape',
    description: 'Un espacio seguro para hablar de lo que importa. Salud mental, relaciones, desarrollo personal y bienestar emocional. Carolina Vega, psicóloga de formación, crea un ambiente íntimo donde los oyentes comparten sus historias y encuentran orientación profesional. El programa más reconfortante del dial, recomendado por la Asociación de Psicología.',
    schedule: 'Lun-Vie 21:00-23:00',
    timezone: 'COT (UTC-5)',
    hosts: [
      { id: 4, name: 'Carolina Vega', photoUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20in%20her%20thirties%2C%20elegant%20and%20approachable%2C%20warm%20studio%20with%20acoustic%20panels%2C%20elegant%20burgundy%20top%2C%20soft%20professional%20lighting%2C%20editorial%20portrait&width=200&height=200&seq=host-carolina-v-thumb&orientation=squarish', role: 'Conductora' },
    ],
    followers: 198000,
    category: 'Salud',
    radioName: 'Radio Élite Digital',
    radioFrequency: '99.1 FM',
    radioId: 4,
    community: { followers: 198000, comments: 38600, shares: 18400, notificationEnabled: true },
    isActive: true,
    createdAt: '2024-08-05',
    tags: ['salud-mental', 'bienestar', 'psicología', 'desarrollo-personal', 'comunidad'],
  },
  {
    id: 5,
    name: 'Onda Nocturna',
    slug: 'onda-nocturna',
    coverUrl: 'https://readdy.ai/api/search-image?query=Dark%20moody%20night%20radio%20studio%20with%20purple%20and%20blue%20neon%20ambient%20lighting%2C%20vinyl%20turntables%20visible%2C%20DJ%20mixer%20with%20glowing%20knobs%2C%20atmospheric%20haze%20effect%2C%20sophisticated%20underground%20music%20club%20aesthetic%2C%20editorial%20photography%20with%20deep%20shadows%20and%20colored%20accents&width=800&height=450&seq=program-cover-onda-nocturna&orientation=landscape',
    description: 'El after hours del dial. Tres horas de electrónica, indie y sonidos alternativos curados por Álex Mendoza, DJ y productor. Cada noche es un viaje sonoro distinto: guest mixes, sesiones en vivo desde el estudio, estrenos exclusivos y la participación de la comunidad que vota los tracks. El programa nocturno más escuchado de Latinoamérica.',
    schedule: 'Lun-Jue 22:00-01:00',
    timezone: 'COT (UTC-5)',
    hosts: [
      { id: 5, name: 'Alejandro "Álex" Mendoza', photoUrl: 'https://readdy.ai/api/search-image?query=Male%20radio%20DJ%20and%20music%20host%20in%20his%20thirties%2C%20cool%20and%20stylish%20with%20headphones%2C%20modern%20music%20studio%20with%20vinyl%2C%20black%20t-shirt%2C%20warm%20moody%20lighting%2C%20editorial%20portrait&width=200&height=200&seq=host-alex-m-thumb&orientation=squarish', role: 'DJ / Conductor' },
    ],
    followers: 246000,
    category: 'Música',
    radioName: 'Estéreo Capital',
    radioFrequency: '102.1 FM',
    radioId: 2,
    community: { followers: 246000, comments: 52100, shares: 22300, notificationEnabled: true },
    isActive: true,
    createdAt: '2024-04-18',
    tags: ['electrónica', 'indie', 'DJ', 'nocturno', 'sesiones-en-vivo'],
  },
  {
    id: 6,
    name: 'Noticiero Primera Edición',
    slug: 'noticiero-primera-edicion',
    coverUrl: 'https://readdy.ai/api/search-image?query=Professional%20news%20broadcast%20studio%20with%20large%20digital%20screens%20showing%20world%20maps%20and%20headlines%2C%20clean%20modern%20newsroom%20aesthetic%2C%20serious%20yet%20approachable%20atmosphere%2C%20morning%20light%20through%20frosted%20glass%2C%20editorial%20news%20photography%20style%20with%20crisp%20professional%20composition&width=800&height=450&seq=program-cover-noticiero-primera-edicion&orientation=landscape',
    description: 'La información que necesita para empezar el día. Gabriela Sotomayor lidera el noticiero matutino más riguroso del país, con corresponsales en 8 ciudades y un equipo de investigación que ha destapado casos de alto impacto. Dos horas de noticias verificadas, análisis político, económica y cobertura internacional sin sensacionalismo.',
    schedule: 'Lun-Vie 07:00-09:00',
    timezone: 'CLT (UTC-4)',
    hosts: [
      { id: 6, name: 'Gabriela Sotomayor', photoUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20news%20anchor%20in%20her%20forties%2C%20authoritative%20yet%20warm%20presence%2C%20newsroom%20background%20with%20screens%2C%20navy%20professional%20attire%2C%20confident%20expression%2C%20editorial%20portrait&width=200&height=200&seq=host-gabriela-s-thumb&orientation=squarish', role: 'Conductora' },
    ],
    followers: 178000,
    category: 'Noticias',
    radioName: 'Radio Industria',
    radioFrequency: '93.5 FM',
    radioId: 5,
    community: { followers: 178000, comments: 28500, shares: 41200, notificationEnabled: true },
    isActive: true,
    createdAt: '2024-02-28',
    tags: ['noticias', 'investigación', 'política', 'economía', 'internacional'],
  },
  {
    id: 7,
    name: 'Modo Creativo',
    slug: 'modo-creativo',
    coverUrl: 'https://readdy.ai/api/search-image?query=Modern%20gaming%20and%20tech%20podcast%20studio%20with%20RGB%20LED%20strips%2C%20multiple%20monitors%20displaying%20game%20streams%2C%20neon%20gaming%20peripherals%2C%20fun%20colorful%20aesthetic%2C%20youthful%20energetic%20broadcast%20atmosphere%2C%20editorial%20photography%20with%20cyberpunk-inspired%20lighting&width=800&height=450&seq=program-cover-modo-creativo&orientation=landscape',
    description: 'Donde el gaming, la tecnología y la cultura geek se encuentran. Diego Quintero trae las últimas novedades del mundo tech, reseñas de videojuegos, entrevistas a desarrolladores y creadores de contenido, y la comunidad más activa de la plataforma. El chat en vivo es una fiesta constante. 2 millones de descargas en podcast y contando.',
    schedule: 'Lun-Vie 19:00-21:00',
    timezone: 'ART (UTC-3)',
    hosts: [
      { id: 7, name: 'Diego Armando Quintero', photoUrl: 'https://readdy.ai/api/search-image?query=Young%20male%20radio%20host%20in%20his%20twenties%2C%20enthusiastic%20and%20charismatic%2C%20modern%20podcast%20studio%2C%20colorful%20hoodie%2C%20genuine%20smile%2C%20creative%20lighting%2C%20editorial%20portrait&width=200&height=200&seq=host-diego-q-thumb&orientation=squarish', role: 'Conductor' },
    ],
    followers: 420000,
    category: 'Tecnología',
    radioName: 'Radio Élite Digital',
    radioFrequency: '99.1 FM',
    radioId: 4,
    community: { followers: 420000, comments: 125000, shares: 56800, notificationEnabled: true },
    isActive: true,
    createdAt: '2025-01-20',
    tags: ['gaming', 'tecnología', 'geek', 'podcast', 'streaming'],
  },
  {
    id: 8,
    name: 'Clásicos del Mundo',
    slug: 'clasicos-del-mundo',
    coverUrl: 'https://readdy.ai/api/search-image?query=Elegant%20classical%20music%20radio%20studio%20with%20grand%20piano%20in%20soft%20focus%20background%2C%20sheet%20music%20scattered%20on%20a%20wooden%20desk%2C%20warm%20golden%20afternoon%20light%20streaming%20through%20tall%20windows%2C%20sophisticated%20cultural%20atmosphere%2C%20editorial%20photography%20with%20refined%20artistic%20composition&width=800&height=450&seq=program-cover-clasicos-del-mundo&orientation=landscape',
    description: 'Un viaje diario por la música clásica universal. Lucía Fernández, musicóloga de formación, guía a los oyentes por las obras maestras de todos los tiempos con un análisis accesible y apasionado. Desde Bach hasta Piazzolla, cada pieza viene con su historia, su contexto y sus secretos. El espacio cultural más premiado de la radio peruana.',
    schedule: 'Lun-Vie 10:00-12:00',
    timezone: 'PET (UTC-5)',
    hosts: [
      { id: 8, name: 'Lucía Fernández', photoUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20in%20her%20thirties%2C%20sophisticated%20and%20warm%2C%20classical%20music%20studio%20background%2C%20elegant%20silk%20blouse%2C%20soft%20artistic%20lighting%2C%20editorial%20portrait&width=200&height=200&seq=host-lucia-f-thumb&orientation=squarish', role: 'Conductora' },
    ],
    followers: 95000,
    category: 'Cultura',
    radioName: 'Radio Cultura Digital',
    radioFrequency: '91.3 FM',
    radioId: 6,
    community: { followers: 95000, comments: 12300, shares: 8400, notificationEnabled: true },
    isActive: true,
    createdAt: '2024-09-12',
    tags: ['música-clásica', 'cultura', 'análisis-musical', 'divulgación', 'arte'],
  },
  {
    id: 9,
    name: 'Noches de Nostalgia',
    slug: 'noches-de-nostalgia',
    coverUrl: 'https://readdy.ai/api/search-image?query=Vintage%20radio%20studio%20atmosphere%20with%20warm%20sepia-toned%20lighting%2C%20classic%20tube%20radio%20on%20display%2C%20old%20vinyl%20records%20and%20retro%20microphone%2C%20nostalgic%20warm%20amber%20glow%2C%20timeless%20elegant%20broadcast%20aesthetic%2C%20editorial%20photography%20with%20golden%20hour%20warmth%20and%20sentimental%20mood&width=800&height=450&seq=program-cover-noches-de-nostalgia&orientation=landscape',
    description: 'Tres horas para viajar en el tiempo. Hugo Cárdenas, leyenda de la radio con 35 años al aire, abre el baúl de los recuerdos con los grandes éxitos de los 60s, 70s y 80s. Anécdotas, cartas de oyentes, trivia musical y esa voz inconfundible que ha acompañado a tres generaciones. El programa líder de audiencia en su franja desde hace 20 años.',
    schedule: 'Lun-Sáb 20:00-23:00',
    timezone: 'VET (UTC-4)',
    hosts: [
      { id: 9, name: 'Hugo Cárdenas', photoUrl: 'https://readdy.ai/api/search-image?query=Male%20radio%20host%20in%20his%20fifties%2C%20wise%20and%20experienced%20presence%2C%20vintage%20radio%20studio%20with%20classic%20equipment%2C%20vest%20and%20tie%2C%20warm%20nostalgic%20lighting%2C%20editorial%20portrait&width=200&height=200&seq=host-hugo-c-thumb&orientation=squarish', role: 'Conductor' },
    ],
    followers: 156000,
    category: 'Música',
    radioName: 'Radio Peninsular',
    radioFrequency: '101.9 FM',
    radioId: 7,
    community: { followers: 156000, comments: 18500, shares: 9600, notificationEnabled: true },
    isActive: true,
    createdAt: '2023-11-05',
    tags: ['nostalgia', 'retro', 'clásicos', 'música', 'historia-radial'],
  },
  {
    id: 10,
    name: 'Finanzas al Aire',
    slug: 'finanzas-al-aire',
    coverUrl: 'https://readdy.ai/api/search-image?query=Modern%20clean%20financial%20podcast%20studio%20with%20minimalist%20design%2C%20stock%20market%20charts%20on%20screens%2C%20white%20and%20sage%20green%20color%20palette%2C%20natural%20daylight%20through%20large%20windows%2C%20professional%20yet%20approachable%20atmosphere%2C%20editorial%20photography%20with%20fresh%20morning%20aesthetic&width=800&height=450&seq=program-cover-finanzas-al-aire&orientation=landscape',
    description: 'El dinero no tiene que ser complicado. Mariana Duarte, economista y conferencista TEDx, explica finanzas personales, inversiones, ahorro y emprendimiento en un lenguaje que todos entienden. El primer programa radial de educación financiera para jóvenes en Latinoamérica. Cada episodio deja herramientas prácticas que los oyentes pueden aplicar de inmediato.',
    schedule: 'Lun-Vie 08:00-09:00',
    timezone: 'CST (UTC-6)',
    hosts: [
      { id: 10, name: 'Mariana Duarte', photoUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20in%20her%20twenties%2C%20fresh%20and%20energetic%2C%20modern%20minimalist%20studio%2C%20white%20shirt%2C%20natural%20daylight%2C%20editorial%20portrait&width=200&height=200&seq=host-mariana-d-thumb&orientation=squarish', role: 'Conductora' },
    ],
    followers: 188000,
    category: 'Finanzas',
    radioName: 'Radio Costa Azul',
    radioFrequency: '88.7 FM',
    radioId: 8,
    community: { followers: 188000, comments: 22400, shares: 31200, notificationEnabled: true },
    isActive: true,
    createdAt: '2025-03-15',
    tags: ['finanzas-personales', 'inversiones', 'ahorro', 'educación-financiera', 'emprendimiento'],
  },
  {
    id: 11,
    name: 'El Desparche',
    slug: 'el-desparche',
    coverUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20comedy%20radio%20studio%20with%20colorful%20quirky%20decorations%2C%20fun%20neon%20signs%2C%20oversized%20coffee%20mugs%2C%20playful%20chaotic%20yet%20organized%20atmosphere%2C%20bright%20warm%20lighting%2C%20humorous%20editorial%20photography%20with%20energetic%20morning%20show%20aesthetic&width=800&height=450&seq=program-cover-el-desparche&orientation=landscape',
    description: 'Las mañanas nunca fueron tan divertidas. Ricky Navarro revolucionó la radio matutina con humor fresco, irreverente y cero filtros. Noticias bizarras, llamadas en vivo, personajes excéntricos y la participación descontrolada del público. "¿Qué más, parceros?" se volvió frase viral continental. Ganador del Martín Fierro digital. El programa que convierte el tráfico en fiesta.',
    schedule: 'Lun-Vie 06:00-09:00',
    timezone: 'COT (UTC-5)',
    hosts: [
      { id: 11, name: 'Ricardo "Ricky" Navarro', photoUrl: 'https://readdy.ai/api/search-image?query=Male%20radio%20comedy%20host%20in%20his%20thirties%2C%20funny%20and%20expressive%20face%2C%20colorful%20studio%20with%20quirky%20decorations%2C%20graphic%20t-shirt%2C%20vibrant%20lighting%2C%20editorial%20portrait&width=200&height=200&seq=host-ricky-n-thumb&orientation=squarish', role: 'Conductor' },
    ],
    followers: 350000,
    category: 'Comedia',
    radioName: 'Estéreo Capital',
    radioFrequency: '102.1 FM',
    radioId: 2,
    community: { followers: 350000, comments: 165000, shares: 78200, notificationEnabled: true },
    isActive: true,
    createdAt: '2024-07-08',
    tags: ['comedia', 'humor', 'matutino', 'improvisación', 'entretenimiento'],
  },
  {
    id: 12,
    name: 'Respira',
    slug: 'respira',
    coverUrl: 'https://readdy.ai/api/search-image?query=Peaceful%20wellness%20radio%20studio%20filled%20with%20plants%20and%20natural%20elements%2C%20soft%20morning%20light%20filtering%20through%20bamboo%20blinds%2C%20meditation%20cushions%20and%20candles%2C%20serene%20calm%20atmosphere%2C%20minimalist%20zen%20aesthetic%2C%20editorial%20photography%20with%20gentle%20natural%20lighting%20and%20tranquil%20mood&width=800&height=450&seq=program-cover-respira&orientation=landscape',
    description: 'Un oasis de calma al amanecer. Sofía Rangel guía meditaciones, ejercicios de respiración y reflexiones para empezar el día con equilibrio. Cada episodio combina una práctica de mindfulness con entrevistas a expertos en bienestar y música ambiental cuidadosamente seleccionada. La comunidad más silenciosa pero profunda de todo el ecosistema RFW.',
    schedule: 'Lun-Vie 06:00-07:00',
    timezone: 'CST (UTC-6)',
    hosts: [
      { id: 12, name: 'Sofía Rangel', photoUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20in%20her%20thirties%2C%20calm%20and%20meditative%20presence%2C%20wellness%20studio%20with%20plants%2C%20linen%20neutral%20clothing%2C%20soft%20natural%20light%2C%20editorial%20portrait&width=200&height=200&seq=host-sofia-r-thumb&orientation=squarish', role: 'Conductora' },
    ],
    followers: 42000,
    category: 'Salud',
    radioName: 'Radio Costa Azul',
    radioFrequency: '88.7 FM',
    radioId: 8,
    community: { followers: 42000, comments: 6100, shares: 3200, notificationEnabled: true },
    isActive: false,
    createdAt: '2025-05-01',
    tags: ['mindfulness', 'meditación', 'bienestar', 'yoga', 'calma'],
  },
];

export const programsMetricsSummary = {
  totalPrograms: 12,
  totalFollowers: 3054000,
  totalComments: 753500,
  totalShares: 338800,
  totalActive: 11,
  totalInactive: 1,
  avgFollowers: 254500,
  avgCommentsPerProgram: 62792,
  mostFollowed: 'Tardes con Vale',
  mostCommented: 'El Desparche',
  mostShared: 'Modo Creativo',
  topCategory: 'Música',
  uniqueHosts: 10,
  uniqueRadios: 6,
};